import { render, staticRenderFns } from "./IdeaList.vue?vue&type=template&id=4b82d4eb&scoped=true"
import script from "./IdeaList.vue?vue&type=script&lang=js"
export * from "./IdeaList.vue?vue&type=script&lang=js"
import style0 from "./IdeaList.vue?vue&type=style&index=0&id=4b82d4eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b82d4eb",
  null
  
)

export default component.exports